var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"cancel-icon",attrs:{"src":require("@/assets/images/cancel-icon.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }